import React from "react";
import { useContent } from "../contexts/ContentContext";
import AttorneyCard from "./AttorneyCard";
import { useAttorneyBioModal } from "../contexts/ModalsContext";

export default function Attorneys() {
  const { attorneys: ATTORNEYS } = useContent();
  const { openAttorneyBio } = useAttorneyBioModal();

  return (
    <section id="attorneys" className="py-28 bg-[#fbf9f6] paper-bg">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs uppercase tracking-[0.3em] text-[#b8924a]">Our Team</span>
          <h2 className="font-serif text-5xl md:text-6xl text-[#1a2c4e] mt-4 leading-tight">
            Meet the <span className="italic">Attorneys</span>
          </h2>
          <div className="gold-divider" />
          <p className="text-[#3a4d6b] text-lg mt-4">
            Experienced. Accessible. Committed to understanding each client&rsquo;s unique needs and goals.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {ATTORNEYS.map((a) => (
            <AttorneyCard key={a.id} attorney={a} onClick={() => openAttorneyBio(a)} />
          ))}
        </div>
      </div>
    </section>
  );
}
